import { useQuery } from 'react-query';
import ActivityLogService from '~/api/services/activityLogs';
import { onError } from '~/utils/helpers';

const getActivityLogs = (data?) => useQuery(
  `activity-logs-list-${data.search}`,
  () => ActivityLogService.getActivityLogList(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getActivityLogsOptions = (data?) => useQuery(
  'get-activity-logs-options',
  () => ActivityLogService.getActivityLogOptions(data),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

export const ActivityLogsQuery = {
  getActivityLogs,
  getActivityLogsOptions
};
